// 1977 Topps Star Wars Series 1 — GENERATED by pipeline-publish (2026-05-29)
// =============================================================================
// Auto-generated from the set draft. Colors, sub-set types, ordering, and the
// SET_REGISTRY entry below are filled in. REVIEW before committing:
//   - Any placeholder color marker (a parallel name not in the standard color
//     map; the commit guard blocks until every one is resolved).
//   - Rule-7 base serial slots on numbered auto/sketch sub-sets (see in-array
//     notes; the warnings list above flags only sub-sets actually missing one).
//   - Sanity-check the auto-classified sub-set `type` and ordering.
//   - Any placeholder in the SET_REGISTRY entry below (only present if no DB
//     sets row exists for this slug, or fields are blank).
//   - A source/specimen pass on parallel names + print runs.
//   - node --check src/sets/1977-series-1.js if committing by hand, then commit + push.
//
// SET_REGISTRY entry (paste into src/setRegistry.js):
//   {
//     id: "1977-series-1",
//     name: "1977 Topps Star Wars Series 1",
//     shortName: "Series 1 1977",
//     year: 1977,
//     brand: "Topps",
//     category: 'Star Wars',
//     releaseDate: "1977",
//     totalCards: 77,
//     description: "Topps 1977 Topps Star Wars Series 1 trading card set.",
//     color: "#888aa0",
//     accentColor: "#f0c040",
//     dataFile: "1977-series-1",
//   },
// =============================================================================

export const SETS = [
  {
    id: "base",
    type: "base",
    title: "BASE",
    parallels: [
        { id: "print-variation-1", name: "* Print Variation", print_run: null, color: "#9aa0c0" },
        { id: "print-variation-2", name: "** Print Variation", print_run: null, color: "#c0a0d0" },
      ],
    cards: [
        { n: "1", name: "Luke Skywalker" },
        { n: "2", name: "See-Threepio and Artoo-Detoo" },
        { n: "3", name: "The little droid, Artoo-Detoo" },
        { n: "4", name: "Space pirate Han Solo" },
        { n: "5", name: "Princess Leia Organa" },
        { n: "6", name: "Ben (Obi-Wan) Kenobi" },
        { n: "7", name: "The villainous Darth Vader" },
        { n: "8", name: "Grand Moff Tarkin" },
        { n: "9", name: "Rebels defend their starship!" },
        { n: "10", name: "Princess Leia - captured!" },
        { n: "11", name: "Artoo is imprisoned by the Jawas" },
        { n: "12", name: "The droids are reunited!" },
        { n: "13", name: "A sale on droids!" },
        { n: "14", name: "Luke checks out his new droid" },
        { n: "15", name: "Artoo-Detoo is left behind" },
        { n: "16", name: "Jawas of Tatooine" },
        { n: "17", name: "Lord Vader threatens Princess Leia!" },
        { n: "18", name: "Artoo-Detoo is missing!" },
        { n: "19", name: "Searching for the little droid" },
        { n: "20", name: "Hunted by the Sand People!" },
        { n: "21", name: "The Tusken Raiders" },
        { n: "22", name: "Rescued by Ben Kenobi" },
        { n: "23", name: "See-Threepio is injured!" },
        { n: "24", name: "Stormtroopers seek the droids!" },
        { n: "25", name: "Luke rushes to save his loved ones" },
        { n: "26", name: "A horrified Luke sees his family killed" },
        { n: "27", name: "Some repairs for See-Threepio" },
        { n: "28", name: "Luke agrees to join Ben Kenobi" },
        { n: "29", name: "Stopped by stormtroopers" },
        { n: "30", name: "Han in the Millennium Falcon" },
        { n: "31", name: "Sighting the Death Star" },
        { n: "32", name: "Lord Vader's Guards" },
        { n: "33", name: "The droids in the Control Room" },
        { n: "34", name: "See-Threepio diverts the guards" },
        { n: "35", name: "Luke and Han as stormtroopers" },
        { n: "36", name: "Blast of the laser rifle!" },
        { n: "37", name: "Cornered in the labyrinth" },
        { n: "38", name: "Luke and Han in the refuse room" },
        { n: "39", name: "Steel walls close in on our heroes!" },
        { n: "40", name: "Droids rescue their masters!" },
        { n: "41", name: "Facing the deadly chasm" },
        { n: "42", name: "Stormtroopers attack!" },
        { n: "43", name: "Luke prepares to swing across the chasm" },
        { n: "44", name: "Han and Chewie shoot it out!" },
        { n: "45", name: "The light sabre" },
        { n: "46", name: "A desperate moment for Ben" },
        { n: "47", name: "Luke prepares for the battle" },
        { n: "48", name: "Artoo-Detoo is loaded aboard" },
        { n: "49", name: "The rebels monitor the raid" },
        { n: "50", name: "Rebel leaders wonder about their fate!" },
        { n: "51", name: "See-Threepio and Princess Leia" },
        { n: "52", name: "Who will win the final Star War?" },
        { n: "53", name: "Battle in outer space!" },
        { n: "54", name: "The victors receive their reward" },
        { n: "55", name: "Han, Chewie and Luke" },
        { n: "56", name: "A day of rejoicing!" },
        { n: "57", name: "Mark Hamill as Luke Skywalker" },
        { n: "58", name: "Harrison Ford as Han Solo" },
        { n: "59", name: "Alec Guinness as Ben Kenobi" },
        { n: "60", name: "Peter Cushing as Grand Moff Tarkin" },
        { n: "61", name: "Mark Hamill in Control Room" },
        { n: "62", name: "Lord Vader's stormtroopers" },
        { n: "63", name: "May the Force be with you!" },
        { n: "64", name: "Governor of Imperial Outlands" },
        { n: "65", name: "Carrie Fisher and Mark Hamill" },
        { n: "66", name: "Amazing robot See-Threepio!" },
    ],
  },
  {
    id: "sticker",
    type: "insert",
    title: "STICKER",
    parallels: [
        { id: "print-variation-1", name: "* Print Variation", print_run: null, color: "#9aa0c0" },
        { id: "print-variation-2", name: "** Print Variation", print_run: null, color: "#c0a0d0" },
      ],
    cards: [
        { n: "1", name: "Luke Skywalker" },
        { n: "2", name: "Princess Leia Organa" },
        { n: "3", name: "Han Solo" },
        { n: "4", name: "Chewbacca the Wookiee" },
        { n: "5", name: "See-Threepio" },
        { n: "6", name: "Artoo-Detoo" },
        { n: "7", name: "Lord Darth Vader" },
        { n: "8", name: "Grand Moff Tarkin" },
        { n: "9", name: "Ben (Obi-Wan) Kenobi" },
        { n: "10", name: "Tusken Raider" },
        { n: "11", name: "Battle in outer space!" },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// Every sub-set above has its own inline array, so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
